import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e908c876"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "content" };
const _hoisted_2 = { class: "content" };
const _hoisted_3 = { class: "content" };
const _hoisted_4 = { class: "content" };
const _hoisted_5 = { class: "content" };
import { decimalize, decimalizeByExchange, setTimezone } from '@/logics/utils';
import { useStore } from '@/store/store';
import NoData from '@/materials/atoms/NoData.vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        list: null
    },
    setup(__props) {
        const props = __props;
        const store = useStore();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.list, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "list"
                    }, [
                        _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(setTimezone)(String(_unref(store).state.userSettings.localTime), item.time, 'YYYY-MM-DD HH:mm:ss')), 1),
                        _createElementVNode("div", {
                            class: _normalizeClass(["content", item.side])
                        }, _toDisplayString(item.side), 3),
                        _createElementVNode("div", _hoisted_2, _toDisplayString(item.pair), 1),
                        _createElementVNode("div", _hoisted_3, _toDisplayString(item.price !== null
                            ? _unref(decimalizeByExchange)(item.price, _unref(store).getters.symbol.pair, _unref(store).state.currencyPairInfo)
                            : '---'), 1),
                        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(decimalize)(item.amount, _unref(store).getters.symbol.base, _unref(store).getters.currencyInfo)), 1),
                        _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(decimalize)(item.fee, _unref(store).getters.symbol.base, _unref(store).getters.currencyInfo)), 1)
                    ]));
                }), 128)),
                _createVNode(NoData, {
                    isShow: props.list.length === 0
                }, null, 8, ["isShow"])
            ]));
        };
    }
});
